import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Compartments from './Compartments';
import Documents from './Documents';
import Locations from './Locations';
import Summary from './Summary';
import TrailerInformation from './TrailerInformation';

const initialState = {
  compartments: [{ capacityInGallons: 0, position: 1 }],
  documents: {
    method27: {
      documentId: null,
    },
    wetTest: {
      documentId: null,
    },
  },
  effectiveDate: null,
  hasMexicanTrailerNumber: false,
  locations: [],
  mexicanTrailerNumber: '',
  vaporTightnessCode: '',
};

const CreateTrailerWizard = ({ onClose }) => {
  const [step, setStep] = useState(1);
  const [trailerState, setTrailerState] = useState(initialState);

  const next = () => {
    setStep(R.inc);
  };
  const prev = () => {
    setStep(R.dec);
  };
  const reset = () => {
    setStep(1);
    setTrailerState(initialState);
  };

  return (
    <Drawer anchor="right" open>
      <Box height={1} width={390}>
        {step === 1 && (
          <TrailerInformation
            next={next}
            onClose={onClose}
            setTrailerState={setTrailerState}
            trailerState={trailerState}
          />
        )}
        {step === 2 && (
          <Documents
            next={next}
            onClose={onClose}
            prev={prev}
            setTrailerState={setTrailerState}
            trailerState={trailerState}
          />
        )}
        {step === 3 && (
          <Compartments
            next={next}
            onClose={onClose}
            prev={prev}
            setTrailerState={setTrailerState}
            trailerState={trailerState}
          />
        )}
        {step === 4 && (
          <Locations
            next={next}
            onClose={onClose}
            prev={prev}
            setTrailerState={setTrailerState}
            trailerState={trailerState}
          />
        )}
        {step === 5 && (
          <Summary
            next={next}
            onClose={onClose}
            prev={prev}
            reset={reset}
            setTrailerState={setTrailerState}
            trailerState={trailerState}
          />
        )}
      </Box>
    </Drawer>
  );
};

CreateTrailerWizard.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CreateTrailerWizard;
